


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getOrderDetailPage } from '@/api/order'

@Component({
  name: 'TabChange'
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics: any
  @Prop({ default: '' }) defaultActivity: any
  private activeIndex: number = this.defaultActivity || 0

  @Watch('defaultActivity')
  private onChange(val) {
    this.activeIndex = Number(val)
  }

  get changedOrderList() {
    return [
      {
        label: '全部体检',
        value: 0
      },
      {
        label: '待体检',
        value: 1,
        num: this.orderStatics.wait
      },
      {
        label: '体检未通过',
        value: 2,
        num: this.orderStatics.notPass
      },
      {
        label: '体检通过',
        value: 5,
        num: this.orderStatics.pass
      },
      {
        label: '待审核',
        value: 3,
        num: this.orderStatics.waitIssued
      },
      {
        label: '已审核',
        value: 4,
        num: this.orderStatics.issued
      }

    ]
  }

  private tabChange(activeIndex: number) {
    this.activeIndex = activeIndex;

    // 更新URL查询参数
    this.$router.push({
      query: {
        ...this.$route.query,
        tab: activeIndex.toString() // 将筛选状态加入URL
      }
    });

    this.$emit('tabChange', activeIndex);
  }


  created() {
    // 从URL初始化筛选状态
    if (this.$route.query.tab) {
      const tab = Number(this.$route.query.tab);
      if (!isNaN(tab) && this.changedOrderList.some(item => item.value === tab)) {
        this.activeIndex = tab;
      }
    }
  }
}
